<template>
  <div class="product-page">
    <!-- 顶部banner -->
    <div class="banner-section" data-aos="fade">
      <div class="banner-content">
        <h1>善信智慧医养助残平台</h1>
        <p>推动传统养老模式向智慧化转型，构建智能化养老服务体系</p>
        <el-button type="primary" round class="consult-btn" @click="_goContact"
          >立即咨询</el-button
        >
      </div>
    </div>

    <!-- 解决方案 -->
    <div class="solutions-section">
      <div class="section-header" data-aos="fade-up">
        <h2>善信智慧医养助残平台</h2>
        <p>覆盖全场景需求</p>
      </div>

      <div class="solution-list">
        <div
          v-for="(item, index) in solutions"
          :key="index"
          class="solution-item"
          :data-aos="index % 2 === 0 ? 'fade-right' : 'fade-left'"
          :data-aos-delay="index * 100"
        >
          <div class="solution-img">
            <!-- 图片位置，您可自行替换 -->
            <img :src="item.imgPlaceholder" alt="" />
          </div>
          <div class="solution-content">
            <h3>{{ item.title }}</h3>
            <p>{{ item.description }}</p>
            <!-- <el-button type="text" class="detail-btn"
              >查看详情 <i class="el-icon-arrow-right"></i
            ></el-button> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 优势特点 -->
    <div class="advantages-section">
      <div class="section-header" data-aos="fade-up">
        <h2>专业自研团队，深耕智慧养老领域</h2>
        <p>善信医养辐射范围广，提供一站式服务</p>
      </div>

      <div class="advantage-list">
        <div
          v-for="(item, index) in advantages"
          :key="index"
          class="advantage-item"
          data-aos="fade-up"
          :data-aos-delay="index * 100"
        >
          <div class="advantage-icon">
            <i :class="item.icon"></i>
          </div>
          <h3>{{ item.title }}</h3>
          <p>{{ item.description }}</p>
        </div>
      </div>
    </div>

    <!-- 联系我们 -->
    <div class="contact-section" data-aos="fade">
      <div class="contact-content">
        <h2>立即体验智慧养老解决方案</h2>
        <p>专业顾问将为您提供1对1咨询服务</p>
        <el-button type="primary" round class="contact-btn" @click="_goContact"
          >联系我们</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import "aos/dist/aos.css";
import AOS from "aos";

export default {
  name: "ProductPage",
  data() {
    return {
      solutions: [
        {
          title: "数据管理中心",
          description: `是专为老人健康管理与服务支持打造的智能化中枢平台。通过物联网、大数据与人工智能技术，平台实时整合智能穿戴设备、居家传感器、社区服务终端等多维数据，构建老人全生命周期健康档案库。
核心功能涵盖：
1.动态健康监测：24小时采集生理指标、活动轨迹等数据，AI算法自动识别异常并分级预警
2.精准服务匹配：基于老人需求标签等300+维度数据分析，智能对接生活服务、康复训练、辅具租赁等18类助残服务
3.决策支持系统：生成区域助残服务热力图、需求缺口分析等管理看板，助力政府精准制定帮扶政策`,
          imgPlaceholder:
            "https://app.shanxinyy.com/minio/homepage/%E5%88%86%E6%94%AF%E5%A4%A7%E5%B1%8F.jpg",
        },
        {
          title: "24小时通话中心",
          description: `打造的紧急响应与情感支持服务平台，依托智能化系统和专业服务团队，全天候提供即时援助与关怀服务。
服务优势：
1.30秒极速响应：智能工单系统确保求助需求第一时间分配至专业坐席
2.全场景覆盖：支持居家、社区、户外等多环境下的即时援助
3.有温度的服务：经过专业培训的客服团队，提供既专业又人性化的支持`,
          imgPlaceholder: "https://app.shanxinyy.com/minio/homepage/kefu.png",
        },
        {
          title: "老人信息档案库",
          description: `专为老年群体设计的智能化数据中枢，通过多源数据融合与AI分析技术，构建国内领先的"一人一档"全生命周期健康管理体系，实现从基础信息管理到精准服务推送的全流程数字化赋能。`,
          imgPlaceholder:
            "https://app.shanxinyy.com/minio/homepage/jiankangdangan.png",
        },
        {
          title: "商家工作台管理界面",
          description: `专为服务商打造的智能化运营中枢，通过模块化设计和大数据看板，赋能商家实现服务全流程的数字化管理。平台采用"一屏统管"理念，集成服务调度、资源管理、质量监控等核心功能，助力商家提升运营效率与服务品质。`,
          imgPlaceholder: "https://app.shanxinyy.com/minio/homepage/shangjia.png",
        },
      ],
      advantages: [
        {
          icon: "el-icon-medal",
          title: "10年行业经验",
          description: "深耕智慧养老领域，服务全国数百家机构",
        },
        {
          icon: "el-icon-cpu",
          title: "自主研发系统",
          description: "拥有完整知识产权，可根据需求定制开发",
        },
        {
          icon: "el-icon-user-solid",
          title: "专业服务团队",
          description: "技术+养老复合型人才，提供全方位支持",
        },
        {
          icon: "el-icon-office-building",
          title: "一站式服务",
          description: "整合当地资源，提供从评估到服务的全链条支持",
        },
      ],
    };
  },
  mounted() {
    // 初始化动画库
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
    });

    // 设置Element主题色
    document.documentElement.style.setProperty("--el-color-primary", "#f97d01");
  },
};
</script>

<style lang="scss">
/* 全局主题色 */
$primary-color: #f97d01;
$primary-light: lighten($primary-color, 35%);

.product-page {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    Arial, sans-serif;
  color: #333;

  /* 通用样式 */
  .section-header {
    text-align: center;
    margin-bottom: 60px;

    h2 {
      font-size: 32px;
      font-weight: 600;
      margin-bottom: 15px;
      color: #333;
    }

    p {
      font-size: 18px;
      color: #666;
    }
  }

  /* Banner区域 */
  .banner-section {
    height: 500px;
    background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
      url("https://app.shanxinyy.com/minio/homepage/jinrongdashaBj.jpg")
        center/cover no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    text-align: center;

    .banner-content {
      max-width: 800px;
      padding: 0 20px;

      h1 {
        font-size: 42px;
        font-weight: 600;
        margin-bottom: 20px;
        line-height: 1.3;
      }

      p {
        font-size: 20px;
        margin-bottom: 30px;
      }
    }

    .consult-btn {
      padding: 12px 36px;
      font-size: 18px;
      background-color: $primary-color;
      border: none;
      transition: all 0.3s;

      &:hover {
        background-color: darken($primary-color, 10%);
        transform: translateY(-3px);
        box-shadow: 0 5px 15px rgba($primary-color, 0.4);
      }
    }
  }

  /* 解决方案区域 */
  .solutions-section {
    padding: 80px 0;
    background-color: #fff;

    .solution-list {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 20px;
    }

    .solution-item {
      display: flex;
      margin-bottom: 60px;
      background: #f9f9f9;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
      transition: transform 0.3s;

      &:hover {
        transform: translateY(-5px);
      }

      &:nth-child(even) {
        flex-direction: row-reverse;
      }
    }

    .solution-img {
      flex: 1;
      min-height: 300px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .solution-content {
      flex: 1;
      padding: 40px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      h3 {
        font-size: 24px;
        margin-bottom: 20px;
        color: #333;
      }

      p {
        font-size: 16px;
        line-height: 1.6;
        color: #666;
        margin-bottom: 30px;
      }
    }

    .detail-btn {
      align-self: flex-start;
      color: $primary-color;
      font-size: 16px;
      padding: 0;

      i {
        margin-left: 5px;
        transition: transform 0.3s;
      }

      &:hover {
        i {
          transform: translateX(5px);
        }
      }
    }
  }

  /* 优势特点区域 */
  .advantages-section {
    padding: 80px 0;
    background-color: #f5f7fa;

    .advantage-list {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 20px;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      gap: 30px;
    }

    .advantage-item {
      background: #fff;
      padding: 30px;
      border-radius: 8px;
      text-align: center;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
      transition: all 0.3s;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
      }
    }

    .advantage-icon {
      width: 80px;
      height: 80px;
      margin: 0 auto 20px;
      background: $primary-light;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 36px;
        color: $primary-color;
      }
    }

    h3 {
      font-size: 20px;
      margin-bottom: 15px;
      color: #333;
    }

    p {
      font-size: 15px;
      color: #666;
      line-height: 1.6;
    }
  }

  /* 联系我们区域 */
  .contact-section {
    padding: 100px 0;
    background: linear-gradient(
      135deg,
      $primary-color,
      darken($primary-color, 10%)
    );
    color: #fff;
    text-align: center;

    .contact-content {
      max-width: 800px;
      margin: 0 auto;
      padding: 0 20px;

      h2 {
        font-size: 36px;
        margin-bottom: 20px;
      }

      p {
        font-size: 18px;
        margin-bottom: 30px;
        opacity: 0.9;
      }
    }

    .contact-btn {
      padding: 12px 36px;
      font-size: 18px;
      background-color: #fff;
      color: $primary-color;
      border: none;
      transition: all 0.3s;

      &:hover {
        background-color: rgba(255, 255, 255, 0.9);
        transform: translateY(-3px);
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
      }
    }
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .banner-section {
    height: 400px;

    h1 {
      font-size: 32px !important;
    }

    p {
      font-size: 16px !important;
    }
  }

  .solution-item {
    flex-direction: column !important;

    .solution-img {
      min-height: 200px !important;
    }
  }

  .advantage-list {
    grid-template-columns: 1fr !important;
  }
}
</style>
